import React from 'react';
import './labelsPrint.css';

const LabelsPrintableComponent = React.forwardRef(
  ({ summaryData, day, date, formatTimeToAMPM }, ref) => {
    return (
      <div ref={ref} className="printable-container-labels">
        {summaryData.map((list, listIndex) => (
          <div key={listIndex}>
            {list.lines.map((line, lineIndex) => (
              <div key={lineIndex}>
                {line.products.map((product, productIndex) => (
                  <div key={productIndex}>
                    {product.ingredientDetails.map((ingredient, ingredientIndex) => {
                      const fullMixes = Math.floor(ingredient.mixes);

                      return (
                        <React.Fragment key={ingredientIndex}>
                          {ingredient.mixTimes.map((mix, i) => (
                            <div key={ingredientIndex} className="label-box">
                              List: {list.listName} {day} {date} <br />
                              Line: {line.lineName} <br />
                              <span className="label-line product-name">{product.productName} {i + 1} {ingredient.mixTimes[i].type === "rework" ? "Rework" : null}
                              </span> {ingredient.ingredientCode ? ingredient.ingredientCode : null}
                              <br />
                              {ingredient.manufacturerCode && <>Dough: {ingredient.manufacturerCode} <br /></>}
                              <table>
                                <thead>
                                  <tr>
                                    <th>Mix</th>
                                    <th>Repose</th>
                                    <th>Run</th>
                                    <th>Temp </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>{formatTimeToAMPM(ingredient.mixTimes[i].startMixTime)}</td>
                                    <td>{formatTimeToAMPM(ingredient.mixTimes[i].startReposeTime)}</td>
                                    <td>{formatTimeToAMPM(ingredient.mixTimes[i].startTime)}</td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>

                          ))}
                        </React.Fragment>
                      );
                    })}
                  </div>
                ))}
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  }
);

export default LabelsPrintableComponent;
